"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insertItemAfter = exports.insertItemBefore = exports.getContextMenuItem = exports.removeContextMenuItem = void 0;
var utils_1 = require("../../../base-utils/utils");
var common_1 = require("@devexpress/utils/lib/utils/common");
function findContextMenuItemInfoById(items, id) {
    return common_1.isNumber(id) || common_1.isString(id) ?
        utils_1.searchTreeItem(items, function (item) { return item.id === id; }) :
        utils_1.searchTreeItem(items, function (item) { return item === id; });
}
function removeContextMenuItem(items, id) {
    var itemInfo = findContextMenuItemInfoById(items, id);
    return itemInfo === null ? null : itemInfo.parentList.splice(itemInfo.itemIndex, 1)[0];
}
exports.removeContextMenuItem = removeContextMenuItem;
function getContextMenuItem(items, id) {
    var result = utils_1.searchTreeItem(items, function (item) { return item.id === id; });
    return result === null ? null : result.item;
}
exports.getContextMenuItem = getContextMenuItem;
function insertItemBefore(items, item, targetBefore) {
    var itemInfo = findContextMenuItemInfoById(items, targetBefore);
    if (itemInfo)
        itemInfo.parentList.splice(itemInfo.itemIndex, 0, item);
    else
        items.push(item);
}
exports.insertItemBefore = insertItemBefore;
function insertItemAfter(items, item, targetAfter) {
    var itemInfo = findContextMenuItemInfoById(items, targetAfter);
    if (itemInfo)
        itemInfo.parentList.splice(itemInfo.itemIndex + 1, 0, item);
    else
        items.push(item);
}
exports.insertItemAfter = insertItemAfter;
